import client from '../../apollo';
import { gql } from '@apollo/client'
import apiClient from 'ps-components/lib/apiClient';

export const GET_INITIAL_STATE = 'GET_INITIAL_STATE';
export const SELECT_PAY_ELEMENT = 'SELECT_PAY_ELEMENT';
export const SET_SELECTED_YEAR_OVER_YEAR_DATA = 'SET_SELECTED_YEAR_OVER_YEAR_DATA';
export const SET_OVERALL_COMPOSITE_JOB = 'SET_OVERALL_COMPOSITE_JOB';
export const SET_YEAR_OVER_YEAR_DISPLAY_IN = 'SET_YEAR_OVER_YEAR_DISPLAY_IN';
export const SET_YEAR_OVER_YEAR_BENCHMARK_YEAR = 'SET_YEAR_OVER_YEAR_BENCHMARK_YEAR';
export const GET_OVERALL_COMPOSITE_SUCCESS = 'GET_OVERALL_COMPOSITE_SUCCESS';
export const RESET_OVERALL_COMPOSITE = 'RESET_OVERALL_COMPOSITE';
export const TOGGLE_SHOW_AS_PERCENTAGE = 'TOGGLE_SHOW_AS_PERCENTAGE';
export const SHOW_OVERALL_COMPOSITES = 'SHOW_OVERALL_COMPOSITES';
export const SHOW_SURVEY_JOB_MATCHES = 'SHOW_SURVEY_JOB_MATCHES';
export const GET_SURVEY_JOB_MATCHES_START = 'GET_SURVEY_JOB_MATCHES_START';
export const GET_SURVEY_JOB_MATCHES_SUCCESS = 'GET_SURVEY_JOB_MATCHES_SUCCESS';
export const GET_SURVEY_JOB_MATCHES_ERROR = 'GET_SURVEY_JOB_MATCHES_ERROR';
export const SHOW_SURVEY_JOB_DRILLDOWN = 'SHOW_SURVEY_JOB_DRILLDOWN';
export const YEAR_OVER_YEAR_PRINT_START = 'YEAR_OVER_YEAR_PRINT_START';
export const YEAR_OVER_YEAR_PRINT_SUCCESS = 'YEAR_OVER_YEAR_PRINT_SUCCESS';
export const YEAR_OVER_YEAR_PRINT_ERROR = 'YEAR_OVER_YEAR_PRINT_ERROR';
export const RESET_YEAR_OVER_YEAR_ERRORS = 'RESET_YEAR_OVER_YEAR_ERRORS';

export function getOverallComposite(orgJobCode, orgJobCodeKey, benchmarkYear, displayIn) {
  return async dispatch => {
    try {
      const response = await apiClient.apiGet('/api/market-pricing/year-over-year/overallComposite', {
        params: {
          orgJobCode,
          orgJobCodeKey,
          benchmarkYear,
          displayIn
        }
      });

      dispatch({ type: GET_OVERALL_COMPOSITE_SUCCESS, data: response.data });

      if (response.data && response.data.overallComposite && response.data.overallComposite.metadata) {
        if (!response.data.overallComposite.metadata.isAllNull) {
          // If the job is priced, then start fetching the survey job matches
          dispatch(
            getSurveyJobMatches(
              orgJobCode,
              orgJobCodeKey,
              benchmarkYear,
              displayIn,
              response.data.overallComposite.metadata.targetElements
            )
          );
        }
      }
    } catch (error) {
      // TODO Handle errors
      console.log(error);
    }
  };
}

export function getSurveyJobMatches(orgJobCode, orgJobCodeKey, benchmarkYear, displayIn, targetElements) {
  return async dispatch => {
    try {
      dispatch({ type: GET_SURVEY_JOB_MATCHES_START });
      const response = await apiClient.apiGet('/api/market-pricing/year-over-year/surveyJobMatches', {
        params: {
          orgJobCode,
          orgJobCodeKey,
          benchmarkYear,
          displayIn
        }
      });
      dispatch({ type: GET_SURVEY_JOB_MATCHES_SUCCESS, data: response.data, success: response.success });
    } catch (error) {
      // TODO Handle errors
      console.log(error);
      dispatch({ type: GET_SURVEY_JOB_MATCHES_ERROR });
    }
  };
}

export function setYearOverYearDisplayIn(displayIn) {
  return {
    type: SET_YEAR_OVER_YEAR_DISPLAY_IN,
    displayIn
  };
}

export function setYearOverYearBenchmarkYear(benchmarkYear) {
  return {
    type: SET_YEAR_OVER_YEAR_BENCHMARK_YEAR,
    benchmarkYear
  };
}

export function resetYearOverYearErrors() {
  return {
    type: RESET_YEAR_OVER_YEAR_ERRORS
  };
}

export function selectPayElement(payElement) {
  return async dispatch => {
    dispatch({
      type: SELECT_PAY_ELEMENT,
      payElement
    });
  };
}

export function setSelectedYearOverYearData(
  orgJobId,
  orgJobCode,
  orgJobCodeKey,
  benchmarkYear,
  currency,
  jobTitle,
  hideJobCodeKey,
  jobCodeKeyText,
  displayIn
) {
  return async dispatch => {
    dispatch({
      type: SET_SELECTED_YEAR_OVER_YEAR_DATA,
      orgJobId,
      orgJobCode,
      orgJobCodeKey,
      benchmarkYear,
      currency,
      jobTitle,
      hideJobCodeKey,
      jobCodeKeyText,
      displayIn
    });
  };
}

export function getHeaderInfo(id) {
  return async dispatch => {
    if (!id) {
      return;
    }

    try {
      const query = gql`
        query orgJob($id: ID!) {
          orgJob(id: $id) {
            code
            codeKey
            id
            title
            currency
          }
        }
      `;

      const { data } = await client.query({
        query,
        variables: { id },
        fetchPolicy: 'network-only'
      });

      dispatch({ type: SET_OVERALL_COMPOSITE_JOB, data: data.orgJob });
    } catch (error) {
      console.log(error);
    }
  };
}

export function printYearOverYearPdf(
  displayIn,
  orgJobId,
  orgJobCode,
  orgJobCodeKey,
  benchmarkYear,
  csrfPair,
  pdfHeader,
  pdfFooter
) {
  return async dispatch => {
    const params = {
      displayIn,
      orgJobId,
      orgJobCode,
      orgJobCodeKey,
      benchmarkYear,
      headerTemplate: pdfHeader,
      footerTemplate: pdfFooter
    };
    try {
      dispatch({ type: YEAR_OVER_YEAR_PRINT_START });
      const results = await apiClient.apiPost('/api/util/report-print/printYearOverYear', params);
      if (results.data && results.data.success === true && results.data.fileUrl) {
        const fileUrl = results.data.fileUrl;
        window.location = `${fileUrl}&csrf_token=${csrfPair.csrf_token}&csrf_timestamp=${csrfPair.csrf_timestamp}`;
        dispatch({ type: YEAR_OVER_YEAR_PRINT_SUCCESS });
      } else {
        dispatch({ type: YEAR_OVER_YEAR_PRINT_ERROR });
      }
    } catch (error) {
      dispatch({ type: YEAR_OVER_YEAR_PRINT_ERROR });
      throw error;
    }
  };
}

export function resetOverallComposite() {
  return async dispatch => {
    dispatch({ type: RESET_OVERALL_COMPOSITE });
  };
}

export function toggleShowAsPercentage() {
  return async dispatch => {
    dispatch({ type: TOGGLE_SHOW_AS_PERCENTAGE });
  };
}

export function showSurveyJobMatches() {
  return async dispatch => {
    dispatch({ type: SHOW_SURVEY_JOB_MATCHES });
  };
}

export function showOverallComposites() {
  return async dispatch => {
    dispatch({ type: SHOW_OVERALL_COMPOSITES });
  };
}

export function showSurveyJobDrilldown(job) {
  return async dispatch => {
    dispatch({ type: SHOW_SURVEY_JOB_DRILLDOWN, data: job });
  };
}
